import createCache, { EmotionCache } from '@emotion/cache'

/**
 * Creates an Emotion cache with consistent settings for SSR.
 * On the client, uses the emotion insertion point meta tag for proper style ordering.
 */
export default function createEmotionCache(): EmotionCache {
  let insertionPoint: HTMLElement | undefined

  if (typeof document !== 'undefined') {
    // Look for the emotion insertion point meta tag
    const emotionInsertionPoint = document.querySelector<HTMLMetaElement>(
      'meta[name="emotion-insertion-point"]'
    )
    insertionPoint = emotionInsertionPoint ?? undefined
  }

  return createCache({
    key: 'mui',
    insertionPoint,
    prepend: true,
  })
}
